import {
  Badge,
  Box,
  Button,
  Checkbox,
  HStack,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  VStack,
  Spinner,
} from "@chakra-ui/react";
import {
  KYDDashboardWaitlistBuyOrder,
  KYDTicketType,
} from "@common/interfaces/KYDTicket";
import { useState } from "react";
import { formatDate } from "../../../../utils";
import dayjs from "dayjs";

// @david: uncomment this to allow select all
const ALLOW_MULTIPLE_SELECT = true;
const MAX_SELECT = 10;

const orderStatusToColor = (
  orderStatus: KYDDashboardWaitlistBuyOrder["status"]
) => {
  if (orderStatus === "OPEN") {
    return "green";
  }

  if (orderStatus === "CANCELED") {
    return "red";
  }

  if (orderStatus === "FILLED") {
    return "gray";
  }

  if (
    orderStatus === "PENDING_PAYMENT_METHOD" ||
    orderStatus === "PROCESSING"
  ) {
    return "yellow";
  }
};

const WaitlistTable = ({
  timezone,
  isLoading = false,
  orders = [],
  onClickFulfill,
  readOnly = false,
}: {
  readOnly?: boolean;
  timezone?: string;
  isLoading?: boolean;
  orders?: KYDDashboardWaitlistBuyOrder[];
  ticket_types?: KYDTicketType[];
  onClickFulfill: (orders: KYDDashboardWaitlistBuyOrder[]) => Promise<void>;
}) => {
  const [selected, setSelected] = useState([]);

  const getTicketTypeNames = (order: KYDDashboardWaitlistBuyOrder) => {
    return order.cart.line_items.map((li) => li.name).join(",");
  };

  return (
    <HStack spacing={4} w="full" display={"flex"} py={4}>
      <VStack w="100%">
        {ALLOW_MULTIPLE_SELECT && !readOnly ? (
          <HStack w="full">
            <Button
              disabled={selected.length === 0 || isLoading}
              isDisabled={selected.length === 0 || isLoading}
              isLoading={isLoading}
              onClick={() => {
                onClickFulfill(
                  selected.map((i) => orders.find((order) => order.id === i))
                );

                setSelected([]);
              }}
            >
              Fill {selected.length > 0 ? `${selected.length}` : ""} request(s)
            </Button>
            {selected.length > 0 ? (
              <Text>
                {`${selected
                  .map((i) => orders.find((order) => order.id === i).quantity)
                  .reduce((a, b) => a + b, 0)} ticket(s)`}
              </Text>
            ) : null}
          </HStack>
        ) : null}
        <Box overflowX="auto" w="100%">
          <Table>
            <Thead>
              <Tr>
                <Th></Th>
                <Th>Created at</Th>
                <Th>Tickets</Th>
                <Th>Ticket Type</Th>
                <Th>Face Value Total</Th>
                <Th>Status</Th>
              </Tr>
            </Thead>
            <Tbody>
              {orders.map((order) => (
                <Tr key={`${selected.length}-${order.id}`}>
                  {ALLOW_MULTIPLE_SELECT && !readOnly ? (
                    <Td>
                      {order.status === "OPEN" ? (
                        <Checkbox
                          isDisabled={
                            isLoading ||
                            (selected.length >= MAX_SELECT &&
                              !!selected.find(
                                (selected) => selected === order.id
                              ))
                          }
                          defaultChecked={selected.find(
                            (selected) => selected === order.id
                          )}
                          checked={selected.find(
                            (selected) => selected === order.id
                          )}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setSelected((selected) =>
                                selected.concat(order.id)
                              );

                              return;
                            }

                            setSelected((selected) =>
                              selected.filter((id) => id !== order.id)
                            );
                          }}
                        />
                      ) : null}
                      {order.status === "PROCESSING" ? (
                        <Spinner size="sm" />
                      ) : null}
                    </Td>
                  ) : null}
                  <Td width="24%">
                    {formatDate(dayjs(order.created_at).tz(timezone))}
                  </Td>
                  <Td>{order.quantity}</Td>
                  <Td>
                    {/* {getUniqueTicketTypes(order.cart.)
                .map((t) => findTicketTypeNameById(t))
                .join(", ")} */}
                    {getTicketTypeNames(order)}
                  </Td>
                  <Td>{order.face_value_price_display}</Td>
                  <Td>
                    <Badge colorScheme={orderStatusToColor(order.status)}>
                      {order.status}
                    </Badge>
                  </Td>
                </Tr>
              ))}

              {orders.length === 0 ? (
                <Tr>
                  <Td colSpan={4}>
                    <span>No waitlist requests</span>
                  </Td>
                </Tr>
              ) : null}
            </Tbody>
          </Table>
        </Box>
      </VStack>
    </HStack>
  );
};

export default WaitlistTable;
